import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\DocumentPreviewReplaceController::__invoke
* @see app/Http/Controllers/Document/DocumentPreviewReplaceController.php
* @route '/api/editor/document/preview/replace/{type}/{document}/{file_id}'
*/
const DocumentPreviewReplaceController = (args: { type: string | number, document: string | number, file_id: string | number } | [type: string | number, document: string | number, file_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DocumentPreviewReplaceController.url(args, options),
    method: 'post',
})

DocumentPreviewReplaceController.definition = {
    methods: ["post"],
    url: '/api/editor/document/preview/replace/{type}/{document}/{file_id}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Document\DocumentPreviewReplaceController::__invoke
* @see app/Http/Controllers/Document/DocumentPreviewReplaceController.php
* @route '/api/editor/document/preview/replace/{type}/{document}/{file_id}'
*/
DocumentPreviewReplaceController.url = (args: { type: string | number, document: string | number, file_id: string | number } | [type: string | number, document: string | number, file_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            document: args[1],
            file_id: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        document: args.document,
        file_id: args.file_id,
    }

    return DocumentPreviewReplaceController.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace('{file_id}', parsedArgs.file_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\DocumentPreviewReplaceController::__invoke
* @see app/Http/Controllers/Document/DocumentPreviewReplaceController.php
* @route '/api/editor/document/preview/replace/{type}/{document}/{file_id}'
*/
DocumentPreviewReplaceController.post = (args: { type: string | number, document: string | number, file_id: string | number } | [type: string | number, document: string | number, file_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DocumentPreviewReplaceController.url(args, options),
    method: 'post',
})

export default DocumentPreviewReplaceController